import { browser } from '$app/environment';
import { patch_course_user_data } from '$lib/utils/get_user_data';

/** @type {import('./$types').LayoutLoad} */
export async function load({parent, data, depends}) {
    depends('supabase:auth');
    let {supabase, session} = await parent();

    if (browser && session) {
        data.course = await patch_course_user_data(data.course, supabase);
    }

    // Cheap directus preview hack
    const is_admin = session?.user.email === 'zlodie@gmail.com' || session?.user.email === 'step.simoes@gmail.com';
    const is_social_media_simulator_course = data.course.id === "d86a739b-e01e-4201-875d-bd983bb2819b";
    
    if (!is_admin && is_social_media_simulator_course) {
        data.course.lessons = data.course.lessons.map(l => {
            return {
                ...l,
                // @ts-ignore
                posts: l.posts.filter(p => p.status === 'published')
            }
        }).filter(l => l.posts.length > 0);
    }

    return {
        supabase,
        session,
        ...data,
    }
}